module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon-72x72.c10948db4295529db6e24c925043d94b.png";